import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-modal-window-alert",
    styleUrls: ["./modal-window-alert.component.scss"],
    templateUrl: "./modal-window-alert.component.html"
})
export class FUIModalWindowAlertComponent {
    @Input() description: string;
    @Input() title: string;
}
